import { fmtSize } from '@shared/lib/numbers';
import { store } from '../state/store';

interface Level { price: number | null; size: number | null; }

export function renderLevels(
  container: HTMLElement,
  arr: Level[],
  isBid: boolean,
  maxSize: number
): void {
  const neededCells = arr.length * 4;
  if (container.children.length < neededCells) {
    const frag = document.createDocumentFragment();
    while (container.children.length + frag.childNodes.length < neededCells) {
      const actionsCell = document.createElement('div');
      actionsCell.className = 'cell actions-cell';
      const quickBtn = document.createElement('button');
      quickBtn.className = `quick-btn ${isBid ? 'sell' : 'buy'}`;
      quickBtn.textContent = isBid ? 'sell' : 'buy';
      quickBtn.dataset.role = 'quick-btn';
      actionsCell.appendChild(quickBtn);
      frag.appendChild(actionsCell);
      const priceEl = document.createElement('div');
      priceEl.className = `cell price-cell ${isBid ? 'bid' : 'ask'}`;
      priceEl.style.cursor = 'default';
      priceEl.style.padding = '0';
      priceEl.dataset.role = 'level-price';
      frag.appendChild(priceEl);
      const limitCell = document.createElement('div');
      limitCell.className = 'cell limit-cell';
      const limitBtn = document.createElement('button');
      limitBtn.className = `limit-btn ${isBid ? 'buy' : 'sell'}`;
      limitBtn.textContent = isBid ? 'buy' : 'sell';
      limitBtn.dataset.role = 'limit-btn';
      limitCell.appendChild(limitBtn);
      frag.appendChild(limitCell);
      const sizeEl = document.createElement('div');
      sizeEl.className = `cell muted size-cell ${isBid ? 'bid' : 'ask'}`;
      sizeEl.style.padding = '0';
      sizeEl.dataset.role = 'level-size';
      const bar = document.createElement('div');
      bar.className = `level-bar ${isBid ? 'bid-bar' : 'ask-bar'}`;
      const textSpan = document.createElement('span');
      textSpan.className = 'size-text';
      sizeEl.appendChild(bar);
      sizeEl.appendChild(textSpan);
      frag.appendChild(sizeEl);
    }
    container.appendChild(frag);
  }
  for (let i = 0; i < arr.length; i++) {
    const actionsCell = container.children[i * 4] as HTMLElement;
    const priceEl = container.children[i * 4 + 1] as HTMLElement;
    const limitCell = container.children[i * 4 + 2] as HTMLElement;
    const sizeEl = container.children[i * 4 + 3] as HTMLElement;
    const level = arr[i];
    const hasPrice = level?.price != null;
    try {
      const assetId = container?.dataset?.assetId ?? '';
      const book = store?.books?.get(assetId);
      const dec = book?.decimals ?? store.priceDecimalsById?.[assetId] ?? 2;
      let displayDec = dec;
      try {
        const mq = typeof window !== 'undefined' && (window as any).matchMedia && (window as any).matchMedia('(orientation: portrait) and (max-width: 700px)');
        if (mq && (mq as any).matches) displayDec = Math.min(2, dec);
      } catch {}
      const nextText = hasPrice && level?.price != null ? Number(level.price).toFixed(displayDec) : '';
      if (priceEl.textContent !== nextText) priceEl.textContent = nextText;
      if (sizeEl.getAttribute('data-price') !== nextText) sizeEl.setAttribute('data-price', nextText);
    } catch {
      const nextText = hasPrice && level?.price != null ? level.price.toFixed(2) : '';
      if (priceEl.textContent !== nextText) priceEl.textContent = nextText;
      if (sizeEl.getAttribute('data-price') !== nextText) sizeEl.setAttribute('data-price', nextText);
    }
    priceEl.classList.toggle('empty', !hasPrice);
    actionsCell.classList.toggle('empty', !hasPrice);
    try {
      const btn = actionsCell.querySelector('button');
      if (btn) {
        const desiredClass = `quick-btn ${isBid ? 'sell' : 'buy'}`;
        if (btn.className !== desiredClass) btn.className = desiredClass;
        const desiredText = isBid ? 'sell' : 'buy';
        if (btn.textContent !== desiredText) btn.textContent = desiredText;
      }
    } catch {}
    limitCell.classList.toggle('empty', !hasPrice);
    try {
      const assetId = container?.dataset?.assetId ?? '';
      const side = isBid ? 'BUY' : 'SELL';
      const p = level?.price;
      const book = store?.books?.get(assetId);
      const dec = book?.decimals ?? store.priceDecimalsById?.[assetId] ?? 2;
      const has = assetId && p != null && isFinite(p) && p > 0 && store.openOrdersIndex?.has(`${assetId}|${side}|${Number(p).toFixed(dec)}`);
      priceEl.classList.toggle('has-order', !!has);
      sizeEl.classList.toggle('has-order', !!has);
    } catch {}
    let bar = sizeEl.querySelector<HTMLElement>('.level-bar');
    if (!bar) { bar = document.createElement('div'); bar.className = `level-bar ${isBid ? 'bid-bar' : 'ask-bar'}`; sizeEl.insertBefore(bar, sizeEl.firstChild || null); }
    let textSpan = sizeEl.querySelector<HTMLElement>('.size-text');
    if (!textSpan) { textSpan = document.createElement('span'); textSpan.className = 'size-text'; sizeEl.appendChild(textSpan); }
    {
      const desired = level?.size != null && hasPrice ? fmtSize(level.size) : '';
      if (textSpan.textContent !== desired) textSpan.textContent = desired;
      try {
        if (limitCell.getAttribute('data-size') !== desired) limitCell.setAttribute('data-size', desired);
      } catch {}
    }
    const v = Number(level?.size);
    const ratio = isFinite(v) && v > 0 && maxSize > 0 ? Math.max(0, Math.min(1, v / maxSize)) : 0;
    const desiredWidth = hasPrice ? `${Math.round(ratio * 50)}%` : '0%';
    if (bar.style.width !== desiredWidth) bar.style.width = desiredWidth;
    if (bar.style.left !== '0') bar.style.left = '0';
    if (bar.style.right !== 'auto') bar.style.right = 'auto';
  }
  while (container.children.length > neededCells) { container.removeChild(container.lastChild!); }
}
